// The Agent filter's "Not assigned" option rides as a sentinel inside the agentIds array, the same
// way Leads does it (see LeadsFilters.vue / leads.js). The backend types agentIds as UUIDs and
// would reject the sentinel, so split it out into the agentNotAssigned flag before every request.
export const AGENT_NOT_ASSIGNED = 'NOT_ASSIGNED';

export const splitAgentFilter = (agentIds) => {
  const selected = agentIds || [];
  return {
    agentIds: selected.filter((id) => id !== AGENT_NOT_ASSIGNED),
    agentNotAssigned: selected.includes(AGENT_NOT_ASSIGNED),
  };
};

export const withAgentNotAssignedOption = (agents, label) => [
  { name: label, id: AGENT_NOT_ASSIGNED },
  ...agents,
];
